export default __webpack_public_path__ + "static/media/mf.d2193fdb.svg";